export interface QuantityColumn {
  quantity: number;
  overs: number;
  markupPct: number;
  adjustAmt: number;
}

export function parseQuantityCols(json: string | null | undefined): QuantityColumn[] {
  if (!json || !json.trim()) return [];
  try {
    const v: unknown = JSON.parse(json);
    if (!Array.isArray(v)) return [];
    return v.map((raw) => {
      const c = raw as Record<string, unknown>;
      return {
        quantity: Number(c.quantity) || 0,
        overs: Number(c.overs) || 0,
        markupPct: Number(c.markupPct) || 0,
        adjustAmt: Number(c.adjustAmt) || 0,
      };
    });
  } catch {
    return [];
  }
}

export function serializeQuantityCols(cols: QuantityColumn[]): string {
  return JSON.stringify(cols);
}
